// resources/js/offline-manager.js

function hasGoodConnection() {
    if (navigator.connection && navigator.connection.effectiveType) {
        const t = navigator.connection.effectiveType;
        if (t === '2g' || t === 'slow-2g') return false;
    }
    return navigator.onLine !== false;
}

function showConnectionToast(message) {
    const toast = document.getElementById('app-connection-toast');
    if (!toast) return;
    if (message) {
        const span = toast.querySelector('span');
        if (span) span.textContent = message;
    }
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3000);
}

// تستخدمه قبل أى تنقل أو ريفريش
function guardAction(onOk) {
    if (!hasGoodConnection()) {
        showConnectionToast('الاتصال بالإنترنت ضعيف أو غير متوفر');
        return;
    }
    onOk();
}

window.AppConnection = {
    hasGoodConnection,
    showConnectionToast,
    guardAction,
};
